import React from "react";
import Login from "./../Login/login";
import Search from "./../Search/search";
import HomePageRoute from "./homePageRoute";
import AuthenticatedRoute from "./authenticatedRoute";
import Browse from "../Browse/browse";
import MyAccount from "../MyAccount/myaccount";
import ManageUsers from "../ManageUsers/manageusers";
import ManageRepository from "../ManageRepository/managerepository";
import ManageAzure from "../ManageAzure/manageazure";
import ManageIndexTemplate from "../ManageIndexTemplate/manageindextemplate";
import ResetPassword from "../ResetPassword/resetpassword";
import OcrIndexTempates from "../Ocr/ocrindextempates";
import NoPermission from "../NoPermission";
import Archive from "../Archive/archive";
import AuthCallback from "./AuthCallback";
import { Route } from "react-router-dom";
import AzurePreAuthPage from "../Login/AzurePreAuthPage";

class RoutePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div>
        <Route
          path="/auth/callback"
          exact
          render={(routeProps) => (
            <AuthCallback
              {...routeProps}
              setUserPermissions={this.props.props.setUserPermissions}
              userHasAuthenticated={this.props.props.userHasAuthenticated}
              userIpAddress={this.props.props.userIpAddress}
            />
          )}
        />
        <HomePageRoute
          path="/"
          exact
          component={Login}
          props={this.props}
        ></HomePageRoute>
        <HomePageRoute
          exact
          path="/login/azure"
          component={AzurePreAuthPage}
          props={this.props}
        />
        <HomePageRoute
          path="/login/reset"
          exact
          component={ResetPassword}
          props={this.props}
        ></HomePageRoute>
        {/* No Permission Route */}
        <HomePageRoute
          path="/no-permission"
          exact
          component={NoPermission}
          props={this.props}
        />
        <AuthenticatedRoute
          path="/search"
          exact
          component={Search}
          props={this.props}
        ></AuthenticatedRoute>
        <AuthenticatedRoute
          path="/browse"
          exact
          component={Browse}
          props={this.props}
        ></AuthenticatedRoute>
        <AuthenticatedRoute
          path="/myaccount"
          exact
          component={MyAccount}
          props={this.props}
        ></AuthenticatedRoute>
        <AuthenticatedRoute
          path="/manageusers"
          exact
          component={ManageUsers}
          props={this.props}
          requiredPermission="hasManageUsers"
        ></AuthenticatedRoute>
        <AuthenticatedRoute
          path="/managerepository"
          exact
          component={ManageRepository}
          props={this.props}
          requiredPermission="hasManageRepositories"
        ></AuthenticatedRoute>
        <AuthenticatedRoute
          path="/manageazure"
          exact
          component={ManageAzure}
          props={this.props}
          requiredPermission="hasManageClientsUserRole"
        ></AuthenticatedRoute>
        <AuthenticatedRoute
          path="/manageindextemplate"
          exact
          component={ManageIndexTemplate}
          props={this.props}
          requiredPermission="hasManageMetadataTemplate"
        ></AuthenticatedRoute>
        <AuthenticatedRoute
          path="/ocrindextempates"
          exact
          component={OcrIndexTempates}
          props={this.props}
          requiredPermission="hasOcrRole"
        ></AuthenticatedRoute>
        <AuthenticatedRoute
          path="/archive"
          exact
          component={Archive}
          props={this.props}
        ></AuthenticatedRoute>
      </div>
    );
  }
}

export default RoutePage;
